import { useConversationsStore } from '@/stores/conversations/conversations.store';
import type { ConversationType } from '@/types/conversation.types';

export default function newConversation(data: ConversationType): void {
  const conversationsStore = useConversationsStore();

  conversationsStore.updateOrInsertConversation(data);
}
